import React from "react"

import cx from "classnames"
import * as s from "./hosted-video.module.sass"

const HostedVideo = (props) => {
  const { src, poster, parentClass } = props

  return (
    <div className={cx(s.component, parentClass)}>
      <video
        src={src}
        poster={poster}
        autoPlay
        muted
        loop
        playsInline
        preload="none"
      />
    </div>
  )
}

export default HostedVideo
